export default __webpack_public_path__ + "static/media/032-burger.5156798a.svg";